import { Button, FormControl, Grid, Group, IconButton, Layout, Page } from "@/comn/components";
import { useAuth, useFetch, useForm, useGrid, useModal, usePage, useResource, useStore, useToast } from "@/comn/hooks";
import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { APIS, URLS, SF_SVR_INFO, SG_SVR_LBL_LIST } from "@/tra/tancis/ptli/ewc/svr/services/EwciSvrLstService";
import { comnUtils } from "@/comn/utils";

/*
 * Server detail information
 * !== 서버 상세 정보 ==!
 */
export const EWCI1001004Q = () => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    const { pgeUid, menuId } = usePage();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { pgeStore, setStore, getStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast();
    const modal = useModal();
    const { namespace, name } = useParams(); // Key Information of this Component Router !== 라우터에 정의된 키정보 ==!

    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        svrInfo: useForm({
            defaultSchema: SF_SVR_INFO,
            defaultValues: {
                ...(pgeStore?.form || {}),
            },
        }),
    };

    const grid = {
        svrLblList: useGrid({
            defaultSchema: SG_SVR_LBL_LIST,
        })
    }

    const fetch = {
        // Gets UCR Reception management information. !== UCR 수관 관리 정보를 조회한다.==!
        getSvrInfo: useFetch({
            api: () => {
                return APIS.getSvrInfo(namespace, name);
            },
            onSuccess: (data) => {
                form.svrInfo.setValues(data.resultMap.content.svrInfo);
                grid.svrLblList.setData(comnUtils.getGridData(data.resultMap.content.labelList));
            },
        }),
    };

    /*
     * Declaration Page Init Function
     * !== 화면 초기화 함수 선언  ==!
     */
    useEffect(() => {
        fetch.getSvrInfo.fetch();
    }, []);

    return (
        <Page>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.svrInfo.schema.namespace}></Group.Control>
                            <Group.Control {...form.svrInfo.schema.generateName}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.svrInfo.schema.ip}></Group.Control>
                            <Group.Control {...form.svrInfo.schema.useStatus}></Group.Control>
                        </Group.Row>
                        <Group.Row>
                            <Group.Control {...form.svrInfo.schema.lastUpdate}></Group.Control>
                        </Group.Row>
                    </Group.Section>
                </Group.Body>
            </Group>
            <Group>
                <Group.Body>
                    <Group.Section>
                        <Grid
                            {...grid.svrLblList.grid}
                        />
                    </Group.Section>
                </Group.Body>
            </Group>

            <Layout direction="row">
                <Layout.Left>
                    <Button
                        role="list"
                        onClick={() => {
                            navigate(URLS.ewci1001003q);
                        }}
                    ></Button>
                </Layout.Left>
            </Layout>
        </Page>
    );
};
